$(function(){
  $("a[href^=http]:not([href*='" + location.hostname + "'])").attr("target", "_blank");
  $(document).on("change", ".product-card__bundle select", function(){
    var $selected = $(this).val();
    $(this).parents(".product-form__input").siblings("input[name='id']").val($selected);
  });
  setTimeout(function(){
    if($(".shopify-model-viewer-ui__button--poster").length){
      $(".shopify-model-viewer-ui__button--poster").click();
    }
  },500);
});